// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"styles_helpIcon__uW3aO","title":"styles_title__2Epam"};